/* K Junction – new product page logic */
(function () {
  'use strict';
  var root = document.querySelector('[data-kjp]');
  var jsonEl = document.querySelector('[data-kjp-json]');
  if (!root || !jsonEl) return;
  var P;
  try { P = JSON.parse(jsonEl.textContent); } catch (e) { console.error('[KJ] product data', e); return; }

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var money = function (c) { return 'Rs ' + Math.round(c / 100).toLocaleString('en-US'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };

  /* ---------- options & stock ---------- */
  var CI = P.colourIdx, SI = P.sizeIdx;
  var V = P.variants;
  var uniq = function (arr) { var o = []; arr.forEach(function (x) { if (x != null && o.indexOf(x) < 0) o.push(x); }); return o; };
  var colours = CI >= 0 ? uniq(V.map(function (v) { return v.o[CI]; })) : [];
  var sizes = SI >= 0 ? uniq(V.map(function (v) { return v.o[SI]; })) : [];
  var match = function (v, c, z) { return (CI < 0 || c == null || v.o[CI] === c) && (SI < 0 || z == null || v.o[SI] === z); };
  var qtyOf = function (c, z) { return V.filter(function (v) { return match(v, c, z); }).reduce(function (t, v) { return t + (v.available ? Math.max(v.q, v.q > 0 ? v.q : 1) : 0); }, 0); };
  var variantFor = function (c, z) {
    var list = V.filter(function (v) { return match(v, c, z); });
    return list.filter(function (v) { return v.available; })[0] || list[0] || null;
  };
  var colourOut = function (c) { return qtyOf(c, null) <= 0; };

  var S = { colour: null, size: null, qty: 1, err: '', bad: {} };
  var pre = P.selected ? V.filter(function (v) { return v.id === P.selected; })[0] : null;
  if (colours.length) {
    if (pre) S.colour = pre.o[CI];
    else S.colour = colours.filter(function (c) { return !colourOut(c); })[0] || colours[0];
  }
  if (sizes.length === 1) S.size = sizes[0];
  if (pre && SI >= 0 && pre.available) S.size = pre.o[SI];

  var shortSize = function (z) {
    var s = String(z).trim();
    var m = s.match(/^(\d+)\s*-\s*(\d+)\s*(years?|yrs?|y)$/i); if (m) return m[1] + '–' + m[2] + ' Y';
    m = s.match(/^(\d+)\s*-\s*(\d+)\s*(months?|m)$/i); if (m) return m[1] + '–' + m[2] + ' M';
    var map = { small: 'S', medium: 'M', large: 'L', xlarge: 'XL', 'x large': 'XL', 'extra large': 'XL', xxlarge: 'XXL', 'xx large': 'XXL', xxl: 'XXL' };
    return map[s.toLowerCase()] || s;
  };
  var niceSize = function (z) { return String(z || '').replace(/\s*-\s*/, ' – '); };
  var HEX = { black: '#1b1b1b', white: '#f4f4f2', blue: '#2a5bd7', navy: '#1F2A44', 'navy blue': '#1F2A44', 'persian blue': '#1C39BB', red: '#C62828', maroon: '#6D1B2B', green: '#2E7D32', olive: '#6B6B2E', grey: '#8c8c8c', gray: '#8c8c8c', 'steel grey': '#71797E', brown: '#5A3A2E', khaki: '#BDB07A', beige: '#D8C8A8', fawn: '#C8A97E', pink: '#F48FB1', peach: '#F7B89A', purple: '#7B4BA6', yellow: '#F2C230', mustard: '#D4A017', orange: '#EF7A26', 'sky blue': '#87CEEB', 'light blue': '#9EC9F0', cream: '#F3E9D2', mint: '#A8E6CF', lilac: '#C8A2C8', teal: '#1F7A7A' };
  var hexOf = function (c) { var k = String(c).toLowerCase().trim(); return HEX[k] || HEX[k.split(' ').pop()] || '#D9D4C7'; };

  /* ---------- gallery ---------- */
  var track = $('[data-track]');
  var slides = $$('[data-slide]');
  var thumbs = $$('[data-thumb]');
  var visibleSlides = function () { return slides.filter(function (s) { return !s.classList.contains('kj-hide'); }); };
  var curIdx = 0;
  var setCount = function () {
    var vs = visibleSlides(); var c = $('[data-gcount]');
    if (c) c.textContent = (curIdx + 1) + ' / ' + Math.max(1, vs.length);
    var curSlide = vs[curIdx];
    thumbs.forEach(function (t) { t.classList.toggle('is-on', curSlide && t.getAttribute('data-media-id') === curSlide.getAttribute('data-media-id')); });
  };
  var goTo = function (i, smooth) {
    var vs = visibleSlides(); if (!vs.length || !track) return;
    curIdx = (i + vs.length) % vs.length;
    track.scrollTo({ left: vs[curIdx].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    setCount();
  };
  if (track) {
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var vs = visibleSlides(); var w = track.clientWidth || 1;
        curIdx = Math.max(0, Math.min(vs.length - 1, Math.round(track.scrollLeft / w)));
        setCount();
      }, 60);
    }, { passive: true });
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var id = t.getAttribute('data-media-id');
      var vs = visibleSlides();
      var i = vs.findIndex(function (s) { return s.getAttribute('data-media-id') === id; });
      if (i >= 0) goTo(i);
    });
  });
  var gp = $('[data-gprev]'), gn = $('[data-gnext]');
  if (gp) gp.addEventListener('click', function () { goTo(curIdx - 1); });
  if (gn) gn.addEventListener('click', function () { goTo(curIdx + 1); });
  var colourHasPhotos = function (c) {
    var k = String(c).toLowerCase();
    return slides.some(function (s) { return (s.getAttribute('data-alt') || '').indexOf(k) >= 0; });
  };
  var filterGallery = function () {
    if (colours.length > 1 && S.colour && colourHasPhotos(S.colour)) {
      var k = S.colour.toLowerCase();
      slides.forEach(function (s) { s.classList.toggle('kj-hide', (s.getAttribute('data-alt') || '').indexOf(k) < 0); });
      thumbs.forEach(function (t) {
        var s = slides.filter(function (x) { return x.getAttribute('data-media-id') === t.getAttribute('data-media-id'); })[0];
        t.classList.toggle('kj-hide', !s || s.classList.contains('kj-hide'));
      });
      goTo(0, false);
    } else {
      slides.forEach(function (s) { s.classList.remove('kj-hide'); });
      thumbs.forEach(function (t) { t.classList.remove('kj-hide'); });
      var v = variantFor(S.colour, S.size);
      if (v && v.mid) {
        var i = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(v.mid); });
        if (i >= 0) { goTo(i, false); return; }
      }
      setCount();
    }
  };

  /* ---------- delivery dates (Pakistan time, Mon–Sat, 12 pm cut-off) ---------- */
  var delivery = function () {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Karachi', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var today = new Date(+parts.year, +parts.month - 1, +parts.day);
    var after = +parts.hour >= 12;
    var add = function (d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; };
    var addW = function (d, n) { var x = new Date(d); while (n > 0) { x = add(x, 1); if (x.getDay() !== 0) n--; } return x; };
    var base = after ? add(today, 1) : today;
    while (base.getDay() === 0) base = add(base, 1);
    var a = addW(base, 3), b = addW(base, 6);
    var D = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var same = a.getMonth() === b.getMonth();
    return {
      intro: after ? 'Order now and get it by ' : 'Order before 12 pm today and get it by ',
      range: D[a.getDay()] + ' ' + a.getDate() + (same ? '' : ' ' + M[a.getMonth()]) + ' – ' + D[b.getDay()] + ' ' + b.getDate() + ' ' + M[b.getMonth()],
      short: a.getDate() + (same ? '' : ' ' + M[a.getMonth()]) + ' – ' + b.getDate() + ' ' + M[b.getMonth()]
    };
  };
  var dl = delivery();
  var di = $('[data-del-intro]'), dr = $('[data-del-range]'), ds = $('[data-del-short]');
  if (di) di.textContent = dl.intro; if (dr) dr.textContent = dl.range; if (ds) ds.textContent = dl.short;

  /* ---------- cart total for free-delivery bar ---------- */
  var cartTotal = 0;
  var loadCart = function () {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { cartTotal = c.total_price || 0; render(); }).catch(function () {});
  };
  document.addEventListener('kj:cart-updated', function (e) { if (e.detail && typeof e.detail.total_price === 'number') { cartTotal = e.detail.total_price; render(); } });

  /* ---------- render ---------- */
  var swWrap = $('[data-swatches]'), szWrap = $('[data-sizes]');
  var stockEl = $('[data-stock]');
  var errEl = $('[data-err]');
  var colourBlock = $('[data-colour-block]'), sizeBlock = $('[data-size-block]');

  var buildSwatches = function () {
    if (!swWrap) return;
    swWrap.innerHTML = colours.map(function (c, i) {
      var v = V.filter(function (x) { return x.o[CI] === c && x.img; })[0];
      var inner = v ? '<img src="' + esc(v.img) + '" alt="" loading="lazy">' : '<i style="background:' + hexOf(c) + '"></i>';
      return '<button type="button" class="kjp-sw" data-sw="' + i + '" aria-label="' + esc(c) + '">' + inner + '</button>';
    }).join('');
    $$('[data-sw]', swWrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var c = colours[+b.getAttribute('data-sw')];
        S.colour = c;
        if (S.size && qtyOf(c, S.size) <= 0) S.size = null;
        clearBad('colour');
        filterGallery();
        render();
      });
    });
  };
  var buildSizes = function () {
    if (!szWrap) return;
    szWrap.innerHTML = sizes.map(function (z, i) {
      return '<button type="button" class="kjp-size" data-sz="' + i + '">' + esc(shortSize(z)) + '</button>';
    }).join('');
    $$('[data-sz]', szWrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var z = sizes[+b.getAttribute('data-sz')];
        if (qtyOf(S.colour, z) <= 0) return;
        S.size = z; clearBad('size'); render();
      });
    });
  };

  var currentVariant = function () {
    if (SI >= 0 && !S.size) return null;
    if (CI >= 0 && !S.colour) return null;
    return variantFor(S.colour, S.size);
  };
  var displayVariant = function () { return currentVariant() || variantFor(S.colour, null) || V[0]; };

  var waAsk = function () {
    var lines = ['Assalam o Alaikum K Junction! Mujhe yeh product order karna hai / size ke baare mein poochna hai:', P.title];
    if (S.colour) lines.push('Colour: ' + S.colour);
    if (S.size) lines.push('Size: ' + niceSize(S.size));
    lines.push(P.url);
    return 'https://wa.me/' + P.wa + '?text=' + encodeURIComponent(lines.join('\n'));
  };
  var waNotify = function () {
    var t = 'Assalam o Alaikum K Junction! Jab ' + P.title + (S.colour ? ' ' + S.colour + ' colour' : '') + ' mein wapas stock mein aaye to mujhe WhatsApp par bata dein.\n' + P.url;
    return 'https://wa.me/' + P.wa + '?text=' + encodeURIComponent(t);
  };

  var render = function () {
    var cOut = CI >= 0 ? colourOut(S.colour) : qtyOf(null, null) <= 0;
    // swatches
    $$('[data-sw]', swWrap || root).forEach(function (b) {
      var c = colours[+b.getAttribute('data-sw')];
      var out = colourOut(c);
      b.classList.toggle('is-on', c === S.colour);
      b.classList.toggle('is-out', out);
      b.setAttribute('aria-label', c + (out ? ' – sold out' : ''));
      b.setAttribute('aria-pressed', c === S.colour ? 'true' : 'false');
    });
    var cn = $('[data-colour-name]'); if (cn) cn.textContent = S.colour || '';
    // sizes
    $$('[data-sz]', szWrap || root).forEach(function (b) {
      var z = sizes[+b.getAttribute('data-sz')];
      var q = qtyOf(S.colour, z);
      var out = q <= 0;
      b.classList.toggle('is-out', out);
      b.classList.toggle('is-on', !out && z === S.size);
      b.setAttribute('aria-disabled', out ? 'true' : 'false');
      b.setAttribute('aria-pressed', z === S.size ? 'true' : 'false');
      b.setAttribute('aria-label', z + (out ? ' – sold out' + (S.colour ? ' in ' + S.colour : '') : ''));
      var dot = b.querySelector('.kjp-lowdot');
      if (!out && q <= 3) { if (!dot) { dot = document.createElement('span'); dot.className = 'kjp-lowdot'; b.appendChild(dot); } } else if (dot) dot.remove();
    });
    var sn = $('[data-size-name]');
    if (sn) sn.textContent = cOut ? 'Sold out' : (S.size ? S.size : 'Choose a size');
    // stock line
    if (stockEl) {
      var msg = '', sold = false;
      if (cOut) { msg = (S.colour ? S.colour + ' is' : 'This item is') + ' sold out' + (sizes.length ? ' in all sizes' : ''); sold = true; }
      else {
        var zq = S.size ? qtyOf(S.colour, S.size) : 0;
        var low = (S.size && zq > 0 && zq <= 3) ? S.size : sizes.filter(function (z) { var q = qtyOf(S.colour, z); return q > 0 && q <= 3; })[0];
        if (low) msg = 'Only ' + qtyOf(S.colour, low) + ' left' + (sizes.length ? ' in ' + niceSize(low) : '');
      }
      stockEl.classList.toggle('kj-hide', !msg);
      stockEl.classList.toggle('is-sold', sold);
      stockEl.querySelector('span').textContent = msg;
    }
    // price
    var v = displayVariant();
    var unit = v ? v.price : 0;
    var total = unit * S.qty;
    $('[data-price]').textContent = money(unit);
    var was = $('[data-was]'), save = $('[data-save]'), badge = $('[data-save-badge]');
    if (v && v.cmp > v.price) {
      was.textContent = money(v.cmp); was.classList.remove('kj-hide');
      save.textContent = 'You save ' + money(v.cmp - v.price); save.classList.remove('kj-hide');
      if (badge) { badge.textContent = 'Save ' + Math.round((v.cmp - v.price) * 100 / v.cmp) + '%'; badge.classList.remove('kj-hide'); }
    } else { was.classList.add('kj-hide'); save.classList.add('kj-hide'); if (badge) badge.classList.add('kj-hide'); }
    var al = $('[data-add-label]'); if (al) al.textContent = 'ADD TO CART · ' + money(total);
    $('[data-qty]').textContent = S.qty;
    // sku
    var cv = currentVariant();
    var sku = $('[data-sku]'); if (sku) sku.textContent = 'SKU: ' + ((cv && cv.sku) || (v && v.sku) || '');
    // CTAs
    var notify = $('[data-notify]'), inst = $('[data-instock]');
    notify.classList.toggle('kj-hide', !cOut);
    inst.classList.toggle('kj-hide', cOut);
    notify.href = waNotify();
    var sub = $('[data-notify-sub]'); if (sub) sub.textContent = 'We’ll message you when ' + (S.colour || 'it') + ' is back';
    $('[data-wa]').href = waAsk();
    // error
    if (errEl) { errEl.textContent = S.err; errEl.classList.toggle('kj-hide', !S.err); }
    // free delivery
    renderFree(cartTotal + (cOut ? 0 : total));
    // sticky
    var stS = document.querySelector('[data-st-size]'), stP = document.querySelector('[data-st-price]');
    if (stS) stS.textContent = cOut ? 'Sold out' : (S.size ? niceSize(S.size) : (sizes.length ? 'Choose a size' : ''));
    if (stP) stP.textContent = money(total);
    var stA = document.querySelector('[data-st-add]'), stN = document.querySelector('[data-st-notify]'), stW = document.querySelector('[data-st-wa]');
    if (stA) stA.classList.toggle('kj-hide', cOut);
    if (stN) { stN.classList.toggle('kj-hide', !cOut); stN.href = waNotify(); }
    if (stW) stW.href = waAsk();
    // size guide row marker
    if (SG.open) SG.draw();
  };

  var renderFree = function (sub) {
    var row = $('[data-free-row]'), msg = $('[data-free-msg]'), bar = $('[data-free-bar]'), ico = $('[data-free-ico]');
    if (!row) return;
    var rem = P.freeAt - sub;
    var done = rem <= 0;
    row.classList.toggle('is-done', done);
    msg.textContent = done ? 'FREE DELIVERY UNLOCKED!' : 'Rs' + Math.ceil(rem / 100) + '/- ki aur shopping karein, GET FREE DELIVERY';
    ico.innerHTML = done
      ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'
      : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#17140F" stroke-width="2" stroke-linejoin="round"><path d="M1 4h14v12H1z"/><path d="M15 9h4l3 3v4h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="18.5" cy="18.5" r="2"/></svg>';
    requestAnimationFrame(function () { bar.style.width = Math.min(100, Math.round(sub * 100 / P.freeAt)) + '%'; });
  };

  /* ---------- nudge when colour/size missing ---------- */
  var clearBad = function (k) {
    var el = k === 'colour' ? colourBlock : sizeBlock;
    if (el) el.classList.remove('kj-bad');
    if (S.err) { S.err = ''; }
  };
  var nudge = function (el) {
    if (!el) return;
    el.classList.remove('kj-bad'); void el.offsetWidth; el.classList.add('kj-bad');
  };
  var validate = function () {
    var cOut = CI >= 0 ? colourOut(S.colour) : qtyOf(null, null) <= 0;
    if (cOut) return false;
    var needC = CI >= 0 && !S.colour, needS = SI >= 0 && (!S.size || qtyOf(S.colour, S.size) <= 0);
    if (!needC && !needS) return true;
    if (needC) nudge(colourBlock);
    if (needS) nudge(sizeBlock);
    S.err = needC && needS ? 'Please choose a colour and size' : needC ? 'Please choose a colour' : 'Please choose a size';
    render();
    var target = needC ? colourBlock : sizeBlock;
    if (target) {
      var r = target.getBoundingClientRect();
      if (r.top < 80 || r.bottom > window.innerHeight - 90) window.scrollTo({ top: window.pageYOffset + r.top - 120, behavior: 'smooth' });
    }
    return false;
  };

  /* ---------- add to cart / order now ---------- */
  var busy = false;
  var addToCart = function (btn, then) {
    if (busy || !validate()) return;
    var v = currentVariant(); if (!v) return;
    busy = true; if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: S.qty }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        var item = res.items ? res.items[0] : res;
        if (then === 'checkout') { window.location.href = '/checkout'; return; }
        busy = false; if (btn) btn.classList.remove('is-loading');
        var ev = new CustomEvent('kj:added', { detail: { item: item, handle: P.handle } });
        document.dispatchEvent(ev);
        if (!window.KJCart) window.location.href = '/cart';
        loadCart();
      })
      .catch(function (err) {
        busy = false; if (btn) btn.classList.remove('is-loading');
        S.err = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
        render();
      });
  };
  $('[data-add]').addEventListener('click', function (e) { addToCart(e.currentTarget); });
  $('[data-buynow]').addEventListener('click', function (e) { addToCart(e.currentTarget, 'checkout'); });
  $('[data-inc]').addEventListener('click', function () { S.qty = Math.min(10, S.qty + 1); render(); });
  $('[data-dec]').addEventListener('click', function () { S.qty = Math.max(1, S.qty - 1); render(); });
  var stAdd = document.querySelector('[data-st-add]');
  if (stAdd) stAdd.addEventListener('click', function (e) { addToCart(e.currentTarget); });

  /* sticky bar visibility */
  var sticky = document.querySelector('[data-kjp-sticky]');
  var ctas = $('[data-ctas]');
  if (sticky && ctas && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[0];
      sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(ctas);
  }

  /* ---------- accordion ---------- */
  var acc = $('[data-acc]');
  if (acc) acc.addEventListener('click', function () {
    var body = $('[data-acc-body]'); var open = body.hasAttribute('hidden');
    if (open) body.removeAttribute('hidden'); else body.setAttribute('hidden', '');
    acc.setAttribute('aria-expanded', open ? 'true' : 'false');
    $('[data-acc-sign]').textContent = open ? '−' : '+';
  });

  /* ---------- reviews ---------- */
  var R = P.reviews || [];
  var BG = ['#F9D9A6', '#CFE3D4', '#D6DDF2', '#F3D3DA', '#E8DFF5', '#FCE1C8'];
  var initials = function (n) { return String(n || '?').trim().split(/\s+/).slice(0, 2).map(function (w) { return w[0]; }).join('').toUpperCase(); };
  var starsTxt = function (r) { return '★★★★★'.slice(0, r) + '☆☆☆☆☆'.slice(0, 5 - r); };
  var ri = 0;
  var drawRB = function () {
    var rb = $('[data-rb]'); if (!rb) return;
    if (!R.length) { rb.classList.add('kj-hide'); return; }
    var r = R[ri % R.length];
    var av = $('[data-rb-av]'); av.textContent = initials(r.name); av.style.background = BG[ri % BG.length];
    $('[data-rb-name]').textContent = r.name;
    $('[data-rb-stars]').textContent = starsTxt(r.rating);
    $('[data-rb-stars]').setAttribute('aria-label', r.rating + ' out of 5 stars');
    $('[data-rb-text]').textContent = '“' + r.text + '”';
    $('[data-rb-prod]').textContent = 'Bought: ' + r.product;
  };
  var rp = $('[data-rb-prev]'), rn = $('[data-rb-next]');
  if (rp) rp.addEventListener('click', function () { ri = (ri + R.length - 1) % R.length; drawRB(); });
  if (rn) rn.addEventListener('click', function () { ri = (ri + 1) % R.length; drawRB(); });
  drawRB();
  var list = $('[data-rev-list]');
  if (list) list.innerHTML = R.slice(0, 3).map(function (r) {
    return '<article class="kjp-rev"><div class="kjp-rev__h"><strong>' + esc(r.name) + '</strong>' + (r.verified ? '<span>✓ Verified buyer</span>' : '') + '</div>' +
      '<div class="kjp-rev__s" aria-label="' + r.rating + ' out of 5 stars">' + starsTxt(r.rating) + '</div><p>' + esc(r.text) + '</p>' +
      '<small><a href="' + esc(r.url) + '">' + esc(r.product) + '</a></small></article>';
  }).join('');
  var allBtn = $('[data-all-reviews]'), allBox = $('[data-jdgm-all]');
  if (allBtn && allBox) allBtn.addEventListener('click', function () {
    var show = allBox.hasAttribute('hidden');
    if (show) allBox.removeAttribute('hidden'); else allBox.setAttribute('hidden', '');
    allBtn.textContent = show ? 'Hide reviews' : allBtn.getAttribute('data-label');
  });
  if (allBtn) allBtn.setAttribute('data-label', allBtn.textContent);
  var wr = $('[data-write-review]'), prodBox = $('[data-jdgm-product]');
  if (wr && prodBox) wr.addEventListener('click', function () {
    prodBox.removeAttribute('hidden');
    var tries = 0;
    (function open() {
      var link = prodBox.querySelector('.jdgm-write-rev-link');
      var form = prodBox.querySelector('.jdgm-form-wrapper, .jdgm-form');
      if (link && !(form && form.offsetParent)) link.click();
      if (!link && tries++ < 20) return setTimeout(open, 250);
      prodBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    })();
  });

  /* ---------- size guide ---------- */
  var SG = { open: false, tab: 'chart', unit: 'in', pick: null };
  var sheet = document.querySelector('[data-kjs]');
  var sgBody = sheet && sheet.querySelector('[data-kjs-body]');
  var hasM = sizes.some(function (z) { return /month|newborn/i.test(z); });
  var hasY = sizes.some(function (z) { return /year/i.test(z); }) || (!hasM);
  var keyOf = function (label) {
    var s = String(label).toLowerCase().trim();
    if (/newborn/.test(s)) return 'nb';
    var m = s.match(/^(\d+)\s*-\s*\d+\s*(m|month|months)\b/); if (m) return 'm' + m[1];
    m = s.match(/^(\d+)\s*-\s*\d+\s*(y|year|years|yrs)\b/); if (m) return 'y' + m[1];
    var a = { small: 's', s: 's', medium: 'm', m: 'm', large: 'l', l: 'l', xlarge: 'xl', 'x large': 'xl', xl: 'xl', 'xx large': 'xxl', xxlarge: 'xxl', xxl: 'xxl' };
    if (a[s]) return 'a' + a[s];
    return 'n' + s.replace(/\D/g, '');
  };
  var prodKeys = sizes.map(keyOf);
  var toCm = function (v) {
    var s = String(v).trim(); var n = 0;
    var m = s.match(/^(\d+(?:\.\d+)?)(?:\s+(\d+)\/(\d+))?$/);
    if (m) { n = parseFloat(m[1]) + (m[2] ? (+m[2] / +m[3]) : 0); } else return v;
    var cm = Math.round(n * 2.54 * 2) / 2; return String(cm);
  };
  var KJ = window.KJ_SIZE || {};
  var merge = function (a, b, cols) {
    var rows = [];
    if (a && hasM) rows = rows.concat(a.rows);
    if (b && hasY) rows = rows.concat(b.rows);
    var f = rows.filter(function (r) { return prodKeys.indexOf(keyOf(r[0])) >= 0; });
    return { cols: cols, rows: f.length ? f : rows };
  };
  var pick = function (tbl, idxs, names) { return { title: tbl.title, cols: names, rows: tbl.rows.map(function (r) { return [r[0]].concat(idxs.map(function (i) { return r[i + 1]; })); }), note: tbl.note, head: tbl.head }; };
  var buildTables = function () {
    var keys = String(P.charts || 'NONE').split(',');
    var out = [];
    var set = keys.length > 1;
    keys.forEach(function (k, ki) {
      var t = null;
      switch (k) {
        case 'TOP': case 'TOP_S': case 'TOP_L': case 'SANDO': {
          var mt = merge(KJ.tops_m, KJ.tops_y);
          var idx = k === 'SANDO' ? [0, 1, 2] : k === 'TOP_S' ? [0, 1, 2, 3] : k === 'TOP_L' ? [0, 1, 2, 4] : [0, 1, 2, 3, 4];
          var nm = k === 'SANDO' ? ['Chest', 'Length', 'Shoulder'] : k === 'TOP' ? ['Chest', 'Length', 'Shoulder', 'Sleeve (short)', 'Sleeve (full)'] : ['Chest', 'Length', 'Shoulder', 'Sleeve'];
          t = pick({ rows: mt.rows }, idx, nm); t.title = set ? (k === 'SANDO' ? 'Sando (top)' : 'Top') : ''; t.shape = k === 'TOP_S' || k === 'SANDO' ? 'tee' : 'long';
          break;
        }
        case 'TROUSER': { var tr = merge(KJ.pajama_m, KJ.trouser_y); t = { rows: tr.rows, cols: ['Waist', 'Length'], title: set ? 'Bottom (trouser)' : '', shape: 'pant' }; break; }
        case 'SHORTS': { var sh = merge(KJ.shorts_m, KJ.shorts_y); t = { rows: sh.rows, cols: ['Waist', 'Length'], title: set ? 'Bottom (shorts)' : '', shape: 'short' }; break; }
        case 'MEN_SHIRT': {
          var ms = KJ.men_shirt; var si = P.sleeve === 's' ? [0, 1, 2, 3] : P.sleeve === 'l' ? [0, 1, 2, 4] : [0, 1, 2, 3, 4];
          var sn = P.sleeve === 's' ? ['Chest', 'Length', 'Shoulder', 'Sleeve'] : P.sleeve === 'l' ? ['Chest', 'Length', 'Shoulder', 'Sleeve'] : ['Chest', 'Length', 'Shoulder', 'Sleeve (half)', 'Sleeve (full)'];
          t = pick(ms, si, sn); t.shape = 'shirt'; break;
        }
        case 'MEN_CHINO': t = { rows: KJ.men_chino.rows, cols: KJ.men_chino.cols, head: 'Waist', note: KJ.men_chino.note, shape: 'pant' }; break;
        case 'MEN_SK': out.push({ title: 'Kameez (regular fit)', rows: KJ.men_kameez.rows, cols: KJ.men_kameez.cols, shape: 'long' }); t = { title: 'Shalwar', rows: KJ.men_shalwar.rows, cols: KJ.men_shalwar.cols, shape: 'pant' }; break;
        case 'WOMEN_NS': out.push({ title: 'Shirt', rows: KJ.women_ns_shirt.rows, cols: KJ.women_ns_shirt.cols, shape: 'long' }); t = { title: 'Trouser', rows: KJ.women_ns_trouser.rows, cols: KJ.women_ns_trouser.cols, note: KJ.women_ns_trouser.note, shape: 'pant' }; break;
      }
      if (t) out.push(t);
    });
    return out;
  };
  var TABLES = null;
  var LET = function (tbls) {
    // letters on the drawing: tops A chest, B length, C shoulder, D sleeve; bottoms A waist, B length; sets top A,B bottom C,D
    var set = tbls.length > 1;
    return tbls.map(function (t, ti) {
      return t.cols.map(function (c) {
        var n = c.toLowerCase();
        if (t.shape === 'pant' || t.shape === 'short') {
          if (n.indexOf('waist') === 0) return set ? 'C' : 'A';
          if (n === 'length' || n === 'trouser length') return set ? 'D' : 'B';
          if (n === 'hips') return set ? '' : 'C';
          return '';
        }
        if (n === 'chest') return 'A';
        if (n === 'length' || n === 'shirt length') return 'B';
        if (set) return '';
        if (n === 'shoulder') return 'C';
        if (n.indexOf('sleeve') === 0 && t.cols.filter(function (x) { return x.toLowerCase().indexOf('sleeve') === 0; }).length === 1) return 'D';
        return '';
      });
    });
  };
  var UR = function (n) { return n.indexOf('chest') === 0 ? ' (seena)' : n.indexOf('shoulder') === 0 ? ' (kandha)' : n.indexOf('sleeve') === 0 ? ' (aasteen)' : n.indexOf('waist') === 0 ? ' (kamar)' : n.indexOf('hip') === 0 ? ' (koolha)' : n.indexOf('length') >= 0 ? ' (lambai)' : ''; };
  var HOW = {
    chest: 'Kapra seedha bichha kar, aagay ki taraf aik baghal ki silai se doosri baghal ki silai tak seedha naapein.',
    length: 'Kandhay ke sab se oonchay hissay se (collar ke saath) seedha neechay daaman tak naapein.',
    shoulder: 'Peechay ki taraf, aik kandhay ki silai se doosray kandhay ki silai tak seedha naapein.',
    sleeve: 'Kandhay ki silai se aasteen ke aakhir (cuff) tak naapein.',
    waist: 'Waistband ko seedha bichha kar ooper se aik kinaray se doosray kinaray tak naapein. Elastic ho to usay khainchein nahin.',
    blength: 'Waistband ke ooper se taang ki bahar wali taraf neechay paainchay tak naapein.',
    hips: 'Waistband se thora neechay, sab se chori jagah par seedha naapein.',
    other: 'Kapra seedha bichha kar naapein.'
  };
  var SVG = {
    tee: '<svg width="200" height="168" viewBox="0 0 240 200" role="img" aria-label="Flat T-shirt with measurement lines"><path d="M90 20 Q120 36 150 20 L190 32 L222 70 L196 88 L180 76 L180 186 L60 186 L60 76 L44 88 L18 70 L50 32 Z" fill="#fff" stroke="#17140F" stroke-width="2" stroke-linejoin="round"/><line x1="62" y1="84" x2="178" y2="84" stroke="#B54708" stroke-width="2.5" stroke-dasharray="5 4"/><line x1="146" y1="26" x2="146" y2="184" stroke="#B54708" stroke-width="2.5" stroke-dasharray="5 4"/>{C}<circle cx="98" cy="84" r="10" fill="#B54708"/><text x="98" y="88" text-anchor="middle" font-size="12" font-weight="800" fill="#fff">A</text><circle cx="146" cy="140" r="10" fill="#B54708"/><text x="146" y="144" text-anchor="middle" font-size="12" font-weight="800" fill="#fff">B</text></svg>',
    teeCD: '<line x1="50" y1="12" x2="190" y2="12" stroke="#B54708" stroke-width="2.5" stroke-dasharray="5 4"/><line x1="198" y1="28" x2="230" y2="66" stroke="#B54708" stroke-width="2.5" stroke-dasharray="5 4"/><circle cx="120" cy="12" r="10" fill="#B54708"/><text x="120" y="16" text-anchor="middle" font-size="12" font-weight="800" fill="#fff">C</text><circle cx="214" cy="47" r="10" fill="#B54708"/><text x="214" y="51" text-anchor="middle" font-size="12" font-weight="800" fill="#fff">D</text>',
    long: '<svg width="200" height="168" viewBox="0 0 240 200" role="img" aria-label="Flat long-sleeve top with measurement lines"><path d="M90 20 Q120 36 150 20 L190 32 L228 150 L206 156 L180 86 L180 186 L60 186 L60 86 L34 156 L12 150 L50 32 Z" fill="#fff" stroke="#17140F" stroke-width="2" stroke-linejoin="round"/>{SHIRT}<line x1="62" y1="94" x2="178" y2="94" stroke="#B54708" stroke-width="2.5" stroke-dasharray="5 4"/><line x1="152" y1="26" x2="152" y2="184" stroke="#B54708" stroke-width="2.5" stroke-dasharray="5 4"/>{C}<circle cx="92" cy="94" r="10" fill="#B54708"/><text x="92" y="98" text-anchor="middle" font-size="12" font-weight="800" fill="#fff">A</text><circle cx="152" cy="146" r="10" fill="#B54708"/><text x="152" y="150" text-anchor="middle" font-size="12" font-weight="800" fill="#fff">B</text></svg>',
    longCD: '<line x1="50" y1="12" x2="190" y2="12" stroke="#B54708" stroke-width="2.5" stroke-dasharray="5 4"/><line x1="198" y1="28" x2="236" y2="144" stroke="#B54708" stroke-width="2.5" stroke-dasharray="5 4"/><circle cx="120" cy="12" r="10" fill="#B54708"/><text x="120" y="16" text-anchor="middle" font-size="12" font-weight="800" fill="#fff">C</text><circle cx="217" cy="86" r="10" fill="#B54708"/><text x="217" y="90" text-anchor="middle" font-size="12" font-weight="800" fill="#fff">D</text>',
    shirt: '<path d="M96 22 L120 46 L144 22" fill="none" stroke="#17140F" stroke-width="2"/><line x1="120" y1="46" x2="120" y2="186" stroke="#17140F" stroke-width="1.5"/><circle cx="124" cy="70" r="2.5" fill="#17140F"/><circle cx="124" cy="104" r="2.5" fill="#17140F"/><circle cx="124" cy="160" r="2.5" fill="#17140F"/>',
    pant: '<svg width="{W}" height="{H}" viewBox="0 0 240 220" role="img" aria-label="Flat trouser with measurement lines"><path d="M70 14 L170 14 L182 206 L132 206 L120 82 L108 206 L58 206 Z" fill="#fff" stroke="#17140F" stroke-width="2" stroke-linejoin="round"/><line x1="70" y1="30" x2="170" y2="30" stroke="#17140F" stroke-width="1.5"/><line x1="70" y1="8" x2="170" y2="8" stroke="#B54708" stroke-width="2.5" stroke-dasharray="5 4"/><line x1="200" y1="14" x2="200" y2="206" stroke="#B54708" stroke-width="2.5" stroke-dasharray="5 4"/><circle cx="120" cy="8" r="10" fill="#B54708"/><text x="120" y="12" text-anchor="middle" font-size="12" font-weight="800" fill="#fff">{L1}</text><circle cx="200" cy="110" r="10" fill="#B54708"/><text x="200" y="114" text-anchor="middle" font-size="12" font-weight="800" fill="#fff">{L2}</text></svg>',
    short: '<svg width="{W}" height="{H}" viewBox="0 0 240 130" role="img" aria-label="Flat shorts with measurement lines"><path d="M70 14 L170 14 L184 112 L132 112 L120 72 L108 112 L56 112 Z" fill="#fff" stroke="#17140F" stroke-width="2" stroke-linejoin="round"/><line x1="70" y1="30" x2="170" y2="30" stroke="#17140F" stroke-width="1.5"/><line x1="70" y1="6" x2="170" y2="6" stroke="#B54708" stroke-width="2.5" stroke-dasharray="5 4"/><line x1="198" y1="14" x2="198" y2="112" stroke="#B54708" stroke-width="2.5" stroke-dasharray="5 4"/><circle cx="120" cy="6" r="10" fill="#B54708"/><text x="120" y="10" text-anchor="middle" font-size="12" font-weight="800" fill="#fff">{L1}</text><circle cx="198" cy="64" r="10" fill="#B54708"/><text x="198" y="68" text-anchor="middle" font-size="12" font-weight="800" fill="#fff">{L2}</text></svg>'
  };
  var figFor = function (tbls) {
    var set = tbls.length > 1;
    return tbls.map(function (t) {
      if (t.shape === 'tee') return SVG.tee.replace('{C}', set ? '' : SVG.teeCD).replace('width="200" height="168"', set ? 'width="150" height="126"' : 'width="200" height="168"');
      if (t.shape === 'long' || t.shape === 'shirt') return SVG.long.replace('{SHIRT}', t.shape === 'shirt' ? SVG.shirt : '').replace('{C}', set ? '' : SVG.longCD).replace('width="200" height="168"', set ? 'width="150" height="126"' : 'width="200" height="168"');
      var s = t.shape === 'short' ? SVG.short : SVG.pant;
      return s.replace('{W}', set ? 150 : 220).replace('{H}', set ? (t.shape === 'short' ? 82 : 138) : (t.shape === 'short' ? 120 : 200)).replace('{L1}', set ? 'C' : 'A').replace('{L2}', set ? 'D' : 'B');
    }).join('');
  };
  var stepsFor = function (tbls, letters) {
    var seen = {}; var out = [];
    tbls.forEach(function (t, ti) {
      t.cols.forEach(function (c, ci) {
        var L = letters[ti][ci]; var n = c.toLowerCase();
        var bottom = t.shape === 'pant' || t.shape === 'short';
        var key = (L || '') + n + (bottom ? 'b' : 't');
        if (seen[key]) return; seen[key] = 1;
        var how = n.indexOf('chest') === 0 ? HOW.chest : n.indexOf('shoulder') === 0 ? HOW.shoulder : n.indexOf('sleeve') === 0 ? HOW.sleeve : n.indexOf('waist') === 0 ? HOW.waist : n.indexOf('hip') === 0 ? HOW.hips : (n.indexOf('length') >= 0) ? (bottom ? HOW.blength : HOW.length) : HOW.other;
        var name = (tbls.length > 1 && t.title ? t.title.split(' (')[0] + ' ' + n : c);
        out.push({ L: L, name: name.charAt(0).toUpperCase() + name.slice(1) + (/\(/.test(name) ? '' : UR(n)), how: how });
      });
    });
    out.sort(function (a, b) { return (a.L || 'Z').localeCompare(b.L || 'Z'); });
    return out;
  };
  var tick = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#FFCB05" stroke-width="3.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var tips = P.isKids
    ? [['Size ', 'bachay ki umar ke mutabiq', ' hai (regular fit).'], ['Bacha lamba hai ya do sizes ke beech? ', 'Ek size bara lein.', ''], ['Fit na aaye? ', '14 din mein exchange', ' kar sakte hain.']]
    : [['Yeh ', 'regular fit', ' hai.'], ['Do sizes ke beech hain? ', 'Ek size bara lein.', ''], ['Fit na aaye? ', '14 din mein exchange', ' kar sakte hain.']];
  var tipHTML = '<div class="kjs__tip"><div><span><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#17140F" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.3 15.3l-6.6 6.6a1 1 0 0 1-1.4 0L2.1 10.7a1 1 0 0 1 0-1.4l6.6-6.6a1 1 0 0 1 1.4 0l11.2 11.2a1 1 0 0 1 0 1.4z"/><path d="M7.5 10.5l2 2"/><path d="M10.5 7.5l2 2"/><path d="M13.5 13.5l2 2"/></svg></span><strong>Size tip</strong></div><ul>' +
    tips.map(function (t) { return '<li><span>' + tick + '</span><span>' + t[0] + '<strong>' + t[1] + '</strong>' + t[2] + '</span></li>'; }).join('') + '</ul></div>';

  SG.draw = function () {
    if (!sgBody) return;
    if (!TABLES) TABLES = buildTables();
    var tabs = sheet.querySelector('[data-kjs-tabs]');
    var sel = sheet.querySelector('[data-kjs-select]');
    var mineKey = keyOf(SG.pick || S.size || '');
    if (!TABLES.length && P.chartImg) {
      tabs.classList.add('kj-hide');
      sgBody.innerHTML = '<img class="kjs__chartimg" src="' + esc(P.chartImg) + '" alt="Size chart for ' + esc(P.title) + '">' + tipHTML;
    } else if (!TABLES.length) {
      tabs.classList.add('kj-hide');
      sgBody.innerHTML = '<div class="kjs__empty"><b>Size chart coming soon</b><small>We’re adding exact measurements for this item. Message us on WhatsApp and we’ll send them right away.</small></div>' + tipHTML;
    } else {
      tabs.classList.remove('kj-hide');
      var letters = LET(TABLES);
      if (SG.tab === 'chart') {
        sgBody.innerHTML = TABLES.map(function (t, ti) {
          var head = t.head || (P.isKids ? 'Age' : 'Size');
          return (t.title ? '<div class="kjs__tbltitle">' + esc(t.title) + '</div>' : '') +
            '<div class="kjs__tbl"><table><thead><tr><th>' + head + '</th>' + t.cols.map(function (c, ci) { return '<th>' + esc(c) + (letters[ti][ci] ? ' (' + letters[ti][ci] + ')' : '') + '</th>'; }).join('') + '</tr></thead><tbody>' +
            t.rows.map(function (r) {
              var k = keyOf(r[0]); var mine = k === mineKey;
              return '<tr data-row-key="' + k + '"' + (mine ? ' class="is-mine"' : '') + '><td>' + esc(r[0].replace(/(\d)-(\d)/, '$1 – $2')) + '</td>' + r.slice(1).map(function (v) { return '<td>' + esc(SG.unit === 'cm' ? toCm(v) : v) + '</td>'; }).join('') + '</tr>';
            }).join('') + '</tbody></table></div>' + (t.note ? '<div class="kjs__note">' + esc(t.note) + '</div>' : '');
        }).join('') + '<div class="kjs__note">All measurements in ' + (SG.unit === 'cm' ? 'cm' : 'inches') + ', garment measured laid flat (± 0.5"). Tap a row to choose that size.</div>' +
          '<button type="button" class="kjs__link" data-kjs-tab="measure">A, B, C ka matlab samajh nahin aaya? Dekhein kaise naapna hai</button>' + tipHTML;
        $$('[data-row-key]', sgBody).forEach(function (tr) {
          tr.addEventListener('click', function () {
            var k = tr.getAttribute('data-row-key');
            var z = sizes.filter(function (x) { return keyOf(x) === k; })[0];
            if (z && qtyOf(S.colour, z) > 0) { SG.pick = z; SG.draw(); }
          });
        });
      } else {
        var steps = stepsFor(TABLES, letters);
        sgBody.innerHTML = '<div class="kjs__fig">' + figFor(TABLES) + '</div><ol class="kjs__steps">' + steps.map(function (s) {
          return '<li><span' + (s.L ? '' : ' style="background:#6B6457"') + '>' + (s.L || '•') + '</span><div><strong>' + esc(s.name) + '</strong><small>' + esc(s.how) + '</small></div></li>';
        }).join('') + '</ol><div class="kjs__note">Kapray ko table par seedha bichhayein, silwatein theek karein aur naram measuring tape istemal karein. Elastic ko na khainchein.</div>' + tipHTML;
      }
      $$('[data-kjs-tab]', sgBody).forEach(function (b) { b.addEventListener('click', function () { SG.tab = b.getAttribute('data-kjs-tab'); syncTabs(); SG.draw(); }); });
    }
    var z = SG.pick || S.size;
    sel.textContent = SG.pick && SG.pick !== S.size ? 'Select ' + niceSize(SG.pick) : (z ? 'Continue with ' + niceSize(z) : 'Done');
  };
  var syncTabs = function () {
    $$('[data-kjs-tab]', sheet.querySelector('[data-kjs-tabs]')).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-kjs-tab') === SG.tab); b.setAttribute('aria-selected', b.getAttribute('data-kjs-tab') === SG.tab ? 'true' : 'false'); });
    $$('[data-kjs-unit]', sheet).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-kjs-unit') === SG.unit); });
  };
  var openSG = function () {
    if (!sheet) return;
    SG.open = true; SG.pick = null; SG.tab = 'chart';
    var sub = sheet.querySelector('[data-kjs-sub]');
    var who = { boys: 'Boys', girls: 'Girls', infant: 'Infant', men: 'Men', women: 'Women', kids: 'Kids' }[P.aud] || 'Kids';
    sub.textContent = who + ' · ' + P.title + ' · garment measured laid flat';
    var wa = sheet.querySelector('[data-kjs-wa]');
    wa.href = 'https://wa.me/' + P.wa + '?text=' + encodeURIComponent('Assalam o Alaikum K Junction! Mujhe is product ka size samajhna hai:\n' + P.title + '\n' + (P.isKids ? 'Bachay ki umar: \nQad (height): ' : 'Height: \nWeight: ') + '\n' + P.url);
    syncTabs(); SG.draw();
    sheet.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('is-in'); }); });
  };
  var closeSG = function () {
    if (!sheet) return;
    SG.open = false; sheet.classList.remove('is-in');
    document.documentElement.style.overflow = '';
    setTimeout(function () { sheet.classList.remove('is-open'); }, 280);
  };
  if (sheet) {
    $$('[data-kjs-close]', sheet).forEach(function (b) { b.addEventListener('click', closeSG); });
    $$('[data-kjs-tab]', sheet.querySelector('[data-kjs-tabs]')).forEach(function (b) { b.addEventListener('click', function () { SG.tab = b.getAttribute('data-kjs-tab'); syncTabs(); SG.draw(); }); });
    $$('[data-kjs-unit]', sheet).forEach(function (b) { b.addEventListener('click', function () { SG.unit = b.getAttribute('data-kjs-unit'); syncTabs(); SG.draw(); }); });
    sheet.querySelector('[data-kjs-select]').addEventListener('click', function () {
      if (SG.pick) { S.size = SG.pick; clearBad('size'); render(); }
      closeSG();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && SG.open) closeSG(); });
  }
  var sgl = $('[data-open-sg]'); if (sgl) sgl.addEventListener('click', openSG);

  /* ---------- go ---------- */
  buildSwatches(); buildSizes();
  if (!colours.length && !sizes.length) { /* single-variant product */ }
  filterGallery();
  render();
  loadCart();
  window.KJProduct = { state: S, render: render, openSizeGuide: openSG };
})();
